import { render, staticRenderFns } from "./immobile.vue?vue&type=template&id=04d527f9&scoped=true&"
import script from "./immobile.vue?vue&type=script&lang=js&"
export * from "./immobile.vue?vue&type=script&lang=js&"
import style0 from "./immobile.vue?vue&type=style&index=0&id=04d527f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d527f9",
  null
  
)

export default component.exports